import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { connectLogout } from '../../../actions/telephony';
import { ModalBase } from '../../../common/components';

import { telephonyEnabled } from '../../../utils/telephony';
import { getCookie } from '../../../common/utils/cookie';

function ExitModal() {
  const dispatch = useDispatch();
  const {
    telephony: { status },
    modals: { exitModal: modalOpen },
    theme: { telephony, inPersonTelephony },
  } = useSelector(store => store);

  const [ loading, setLoading ] = useState(false);
  const meetType = getCookie('meetType');

  const tEnabled = telephonyEnabled({ telephony, inPersonTelephony });

  function endCallAndLogout() {
    setLoading(true);

    function closeWindow() {
      dispatch({ type: 'CLOSE_MODAL', modal: 'exitModal' });
      setTimeout(() => window.close(), 100);
    }

    if (status !== 'noauth' && tEnabled) {
      connectLogout()
        .then(() => closeWindow())
        .catch(() => closeWindow());
    } else {
      setTimeout(() => closeWindow(), 1500);
    }
  }

  return (
    <ModalBase
      isOpen={modalOpen}
      width="550px"
      paddingLeft="50px"
      paddingRight="50px"
      paddingBottom="30px"
      handleClose={() => dispatch({ type: 'CLOSE_MODAL', modal: 'exitModal' })}
      closeIcon={false}
    >
      <div className="col">
        <div className="row">
          <h4>Are you sure you want to save and exit?</h4>
        </div>
        <div className="row mb-4 mt-4">
          {tEnabled && (meetType === 'inPerson') && (
            <span className="text-muted">
              By clicking on Exit you will hang up and terminate your call.
              Please click &quot;Go Back to Form&quot; to keep the call in progress.
            </span>
          )}
        </div>

        <hr />

        <div className="row justify-content-between mt-4">
          <button
            type="button"
            disabled={loading}
            className="btn btn-danger"
            style={{ width: '120px' }}
            onClick={endCallAndLogout}
          >
            {loading ? (
              <div className="spinner-border spinner-border-sm me-1" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : null}
            Exit
          </button>
          <button
            type="button"
            className="btn btn-primary"
            style={{ width: '120px' }}
            onClick={() => dispatch({ type: 'CLOSE_MODAL', modal: 'exitModal' })}
          >
            Back to form
          </button>
        </div>
      </div>
    </ModalBase>
  );
}

export default ExitModal;
